'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 116 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("path", {
    id: "robot_svg__a",
    d: "M.338.709h115v97h-115z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M61.44.168C27.509.168 0 26.646 0 59.308s27.508 59.14 61.44 59.14c33.933 0 61.442-26.478 61.442-59.14",
    id: "robot_svg__c"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M61.44.168C27.509.168 0 26.646 0 59.308s27.508 59.14 61.44 59.14c33.933 0 61.442-26.478 61.442-59.14",
    id: "robot_svg__e"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    mask: "url(#robot_svg__b)"
  }, /*#__PURE__*/React__namespace.createElement("g", {
    transform: "rotate(-26 25.68 77.323)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot_svg__c"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.723 50.349a3.52 3.52 0 0 1-4.908.442 3.4 3.4 0 0 1-.448-4.837 3.52 3.52 0 0 1 4.908-.442 3.4 3.4 0 0 1 .448 4.837M18.96 60.724a3.52 3.52 0 0 1-4.908.443 3.4 3.4 0 0 1-.448-4.838 3.52 3.52 0 0 1 4.908-.442 3.401 3.401 0 0 1 .448 4.837m-.552-18.02a8.406 8.406 0 0 0-1.787 7.318c-2.588-.098-5.192.945-6.978 3.058a8.429 8.429 0 0 0 1.112 11.99c3.667 3.007 9.113 2.517 12.165-1.096a8.414 8.414 0 0 0 1.882-4.055l6.207 5.093c1.06.87 2.636.728 3.519-.317a2.439 2.439 0 0 0-.322-3.469l-6.192-5.08a8.598 8.598 0 0 0 3.67-2.548 8.428 8.428 0 0 0-1.111-11.989c-3.666-3.008-9.113-2.518-12.165 1.095",
    fill: "#008ED1",
    mask: "url(#robot_svg__d)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "rotate(-26 25.68 77.323)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "robot_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#robot_svg__e"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M38.787 51.772c-.963 4.513 11.854 18.665 17.374 22.663 5.519 3.997 25.392 8.42 31.844 8.918 6.452.498 2.325-15.153 2.325-15.153S41.386 39.6 38.787 51.772",
    fill: "#888790",
    mask: "url(#robot_svg__f)"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M83.703 97.185c-3.358-13.182-3.297-29.043-3.39-32.834-.125-5.083-2.568-8.022-7.643-8.88-5.075-.856-10.114-2.059-20.282-3.588-6.635-.998-16.729 1.962-22.942 4.14-3.558 1.246-6.095 4.437-6.404 8.154-1.218 14.679 3.653 31.024 8.196 45.855a37.994 37.994 0 0 0 1.447 3.958l51.018-16.805Z",
    fill: "#C0BFC9"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M41.708 109.59a40.685 40.685 0 0 1-.84-2.441c-4.543-14.832-9.415-31.177-8.196-45.855.306-3.7 2.822-6.876 6.352-8.136-3.52.849-6.908 1.929-9.578 2.864-3.558 1.247-6.095 4.438-6.404 8.155-1.218 14.68 3.653 31.024 8.196 45.855a37.994 37.994 0 0 0 1.447 3.958l9.023-4.4Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M88.995 50.153c-2.264 3.684-3.838 7.608-11.806 4.624-7.97-2.983-19.5-9.225-31.515-7.148-12.014 2.077-22.194 5.54-19.243-3.075 2.952-8.614 5.647-17.958 7.99-23.196 2.341-5.237 8.605-11.805 22.205-14.106 13.6-2.3 30.31 4.303 34.94 11.57 6.294 9.883-.306 27.648-2.57 31.331",
    fill: "#C0BFC9"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M35.22 45.487c2.95-8.614 5.646-17.958 7.988-23.196 2.342-5.237 8.606-11.806 22.206-14.105a34.643 34.643 0 0 1 5.833-.46c-4.826-.997-9.91-1.27-14.62-.474-13.601 2.3-19.865 8.868-22.207 14.106-2.342 5.239-5.037 14.582-7.989 23.196-2.015 5.882 2.092 6.133 8.724 5.04-.445-1.204-.461-2.573.064-4.107",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M53.932 16.353c-8.999 3.436-12.004 18.782-7.148 23.371 4.855 4.59 6.342.92 21.066 6.44 14.723 5.52 17.566 5.385 19.833-1.633 2.267-7.018 5.641-13.057.687-18.706-4.954-5.65-22.309-14.104-34.438-9.472",
    fill: "#E3EFF7"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M88.37 25.825C83.675 20.47 67.847 12.607 55.88 15.738c11.653-1.81 25.978 5.47 30.405 10.517 4.954 5.65 1.582 11.689-.686 18.707-.87 2.69-1.826 4.365-3.5 5.102 3.069-.105 4.405-1.89 5.583-5.533 2.268-7.018 5.641-13.057.687-18.706",
    fill: "#888790"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.458 66.454c.107 1.151-.566 2.266-1.668 2.744-3.197 1.386-9.286 5.182-8.131 13.697 1.696 12.513 20.408 11.348 33.384 3.79l2.909 3.516s-16.202 9.597-29.984 5.932C12.186 92.47 11.204 76.84 18.646 69.401c2.637-2.636 5.106-4.148 6.987-5.01 1.714-.785 3.657.255 3.825 2.063M62.315 26.205a.966.966 0 0 1-.398 1.303l-5.252 2.843a.97.97 0 0 1-1.312-.38.966.966 0 0 1 .398-1.304l5.252-2.842a.97.97 0 0 1 1.312.38",
    fill: "#3D3B4A"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M60.694 31.516a.969.969 0 0 1-1.311-.38l-2.807-5.172a.966.966 0 0 1 .398-1.304.97.97 0 0 1 1.312.379l2.806 5.173a.966.966 0 0 1-.398 1.304M83.212 32.25a.967.967 0 0 1-.398 1.304l-5.252 2.841a.97.97 0 0 1-1.312-.379.967.967 0 0 1 .398-1.304L81.9 31.87a.97.97 0 0 1 1.312.379",
    fill: "#3D3B4A"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M81.591 37.561a.97.97 0 0 1-1.311-.38l-2.808-5.172a.966.966 0 0 1 .4-1.304.969.969 0 0 1 1.31.379l2.807 5.173a.966.966 0 0 1-.398 1.304",
    fill: "#3D3B4A"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M67.387 92.315a1.041 1.041 0 0 1-1.453-.2c-.34-.454-.242-1.099.219-1.443a1.04 1.04 0 0 1 1.453.2 1.027 1.027 0 0 1-.219 1.443M51.522 75.093l12.783 18.229c1.006 1.453 3.04 1.773 4.476.704 1.438-1.07 1.705-3.098.588-4.469L55.406 72.206c2.09-2.824 2.197-6.757 0-9.68a8.09 8.09 0 0 0-5.573-3.173l-1.342.998 3.355 4.463-1.8 4.404-4.646.388-3.355-4.463-1.342.997a8.002 8.002 0 0 0 1.484 6.214c2.197 2.922 6.02 3.933 9.335 2.74",
    fill: "#008ED1"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M59.868 76.088s-4.249 3.195-6.774 5.315c-3.545 2.975 1.366 11.126 5.172 9.045 5.06-2.766 9.499-7.97 9.499-7.97l-1.954-2.216L57.75 86.2l-1.413-2.898 4.999-5.061-1.467-2.153ZM112.95 9.259a2.26 2.26 0 0 0-1.875.305 18.91 18.91 0 0 0-6.194-2.116c-4.53-.725-11.714-.188-20.22 6.486a.72.72 0 1 0 .893 1.13c6.374-5.002 12.948-7.147 19.008-6.204 2.452.383 4.367 1.2 5.628 1.88l-.023.067a2.22 2.22 0 0 0 1.538 2.757 2.265 2.265 0 0 0 2.782-1.548 2.22 2.22 0 0 0-1.538-2.757",
    fill: "#3D3B4A"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M81.73 89.574c-5.912-3.989-2.946-12.483 4.202-12.036a4.66 4.66 0 0 1 2.301.782c5.915 3.986 2.95 12.485-4.2 12.035a4.663 4.663 0 0 1-2.302-.781m12.172-12.88-1.3.635a9.954 9.954 0 0 0-2.177-1.86l.49-1.402a.318.318 0 0 0-.199-.408l-4.165-1.414a.326.326 0 0 0-.411.201l-.52 1.489a10.094 10.094 0 0 0-2.763.223l-.71-1.456a.323.323 0 0 0-.433-.147l-3.968 1.936a.323.323 0 0 0-.15.43l.744 1.526c-.684.6-1.276 1.28-1.765 2.021l-1.64-.557a.326.326 0 0 0-.412.2l-1.449 4.152c-.059.169.03.351.2.409l1.658.563a9.904 9.904 0 0 0 .144 2.641l-1.571.766a.323.323 0 0 0-.15.432l1.918 3.935c.078.16.272.225.432.147l1.527-.745a9.862 9.862 0 0 0 2.004 1.813l-.544 1.559a.32.32 0 0 0 .2.408l4.163 1.414a.327.327 0 0 0 .412-.2l.514-1.472c.93.087 1.88.044 2.822-.135l.658 1.35c.078.16.27.225.432.146l3.968-1.935a.322.322 0 0 0 .15-.43l-.624-1.281c.766-.63 1.421-1.36 1.959-2.16l1.327.452a.326.326 0 0 0 .41-.2l1.45-4.153a.32.32 0 0 0-.199-.408l-1.308-.445a9.895 9.895 0 0 0-.178-2.915l1.255-.612a.323.323 0 0 0 .15-.43l-1.919-3.936a.323.323 0 0 0-.432-.147M101.411 81.075l11.856-5.782-2.12-4.347-11.856 5.782z",
    fill: "#008ED1"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m106.776 71.923.79 1.62-4.025 1.963-1.408-2.888 4.643-.695Zm-6.356-2.817 4.63-.693-.515-1.058-4.631.693-1.263-2.59 4.643-.695 2.976 6.101-4.643.695-1.197-2.453Zm-2.406-4.933a1.701 1.701 0 0 1 .793-2.271l.955-.466a1.701 1.701 0 0 1 2.277.774l.729 1.494-4.643.696-.11-.227Z",
    fill: "#008ED1"
  }))));
});
var Robot = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Robot = Robot;